import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { styled, useThemeProps } from '@mui/material/styles';

export interface KeyboardProps extends HTMLAttributes<HTMLElement> {
    children?: ReactNode;
}

const KeyboardRoot = styled('kbd', {
    name: 'MuiKeyboard',
    slot: 'Root',
})(({ theme }) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary,
    marginLeft: 'auto',
    paddingLeft: theme.spacing(2),
}));

export const Keyboard = forwardRef<HTMLElement, KeyboardProps>(function Keyboard(inProps, ref) {
    const props = useThemeProps({ props: inProps, name: 'MuiKeyboard' });
    const { children, className, ...other } = props;

    return (
        <KeyboardRoot ref={ref} className={className} {...other}>
            {children}
        </KeyboardRoot>
    );
});
